import { Capacitor } from '@capacitor/core'

import { isElectron } from '@/utils/isElectron'

import { CapgoUpdater } from './capgo'
import { ElectronUpdater } from './electron'
import { GenericUpdater } from './generic'
import type { Updater } from './updater'

export function getUpdater(): Updater {
  const platform = Capacitor.getPlatform()
  if (isElectron) {
    return new ElectronUpdater()
  } else if (platform === 'ios' || platform === 'android') {
    return new CapgoUpdater()
  }
  return new GenericUpdater()
}
